import { LangService } from '../../services/lang.service';
import { FcmService } from '../../services/fcm.service';
import { RestService } from '../../services/rest.service';
import { UtilService } from '../../services/util.service';
import { NavController, PopoverController, ModalController, LoadingController, AlertController, Platform } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import {Location} from "@angular/common";
import {Capacitor} from '@capacitor/core';
import {OAuthProvider, signInWithPopup} from 'firebase/auth';
import {Auth, UserCredential} from '@angular/fire/auth';
import {SignInWithApple, SignInWithAppleOptions, SignInWithAppleResponse} from '@capacitor-community/apple-sign-in';

@Component({
  selector: 'app-registry',
  templateUrl: './registry.page.html',
  styleUrls: ['./registry.page.scss'],
})
export class RegistryPage implements OnInit {
  showEye1: any;
  item: any;
  tokenFCM: any;
  start: boolean;
  isNew: boolean;
  init: boolean;
  remember: boolean;
  extraQuery: string;
  showEye2: boolean;
  hash: any;
  isMobile: boolean;
  languaje: any;
  loadMostWanted: any;
  searchTop: any;
  helpFocus: boolean;
  showOverSearch: boolean;

  constructor(
    public util: UtilService,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public actRouter: ActivatedRoute,
    public rest: RestService,
    public fcmService: FcmService,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public langService: LangService,
    public platform: Platform,
    public popoverCtrl: PopoverController,
    private pixel: PixelService,
    private locationRouter: Location,
    private auth: Auth,) {
    this.item = {};
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
  }

  ngOnInit() {
    console.log('OnINIT');
    if (!this.platform.is('capacitor')) {
      // G
    }
    /*if (this.fcmService.tokenFCM) {
      this.tokenFCM = this.fcmService.tokenFCM;
    }*/
    this.langService.getLanguajeStorage().then((val => {
      if (val) {
        this.languaje = val;
        console.log('>>>XXX1-home', val);
        this.reloadTrans(val);
      } else {
        console.log('>>>XXX3');
        this.reloadTrans('es');
      }
    }
    )).catch((err) => {
      console.log('>>>XXX5');
      this.reloadTrans('es');
    });
  }

  ionViewWillEnter() {

  }

  onResize(event) {
    console.log(event);
    try {
      if (event.target.innerWidth < 800) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  private reloadTrans(lang) {
    this.translate.use(lang);
    this.langService.setTranslateLanguage(lang);
  }

  changeEye1() {
    if (!this.item.password || this.item.password === '') {
      return;
    }
    this.showEye1 = !this.showEye1;
  }

  changeEye2() {
    if (!this.item.password || this.item.password === '') {
      return;
    }
    this.showEye2 = !this.showEye2;
  }




  valiData() {
    if (!this.item.name || !this.item.email || !this.item.password || !this.hash) {

    } else {
      return true;
    }
  }

  gotoHome() {
    setTimeout(() => {
      this.navCtrl.navigateForward('/login-continue');
    }, 300);
  }
  gotoLogin() {
    this.navCtrl.navigateForward('/login');
  }

  gotoCreate(val) {
    setTimeout(() => {
      if (val === 'user') {
        this.navCtrl.navigateForward('/registry?=' + val);
      } else {
        this.navCtrl.navigateForward('/registry-professional');
      }

    }, 300);
  }


  setRemember() {
    this.remember = !this.remember;
    if (!this.remember) {
      this.rest.storageSet('userLogin', null).catch((err) => console.log(err));
    } else {

    }
  }

  async reg() {
    const email = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$");
    if (this.hash !== this.item.password) {
      const alert = await this.alertCtrl.create({
        header: 'oops!',
        cssClass: 'custom-alert',
        subHeader: this.translate.instant('REG_ERROR_PASS'),
        buttons: ['Ok']
      });
      alert.present();
      return;
    }
    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    if (email.test(this.item.email)) {
      if(this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === false)) {
        window.localStorage.getItem('louderbandToken');
      } else {
        window.localStorage.removeItem('louderbandToken');
      }
      this.item.email = this.item.email.toLowerCase();
      await this.rest._postLogin('security/validate-email', this.item).subscribe(async (response) => {
        loading.dismiss();
        const res: any = response.body;
        console.log('response: ', res);
        if (res.valid) {
          //this.emailExists = false;
          this.util.setDataAux(this.item);
          // const alert = await this.alertCtrl.create({
          //   header: 'Alert',
          //   cssClass: 'custom-alert',
          //   message: 'Te hemos enviado un correo electrónico para verificar tu cuenta.',
          //   buttons: ['OK'],
          // });

          // await alert.present();
          this.navCtrl.navigateForward('/continuar-resgistro');
        } else {
          const alert = await this.alertCtrl.create({
            header: 'Alert',
            cssClass: 'custom-alert',
            message: this.translate.instant('EXISTING_EMAIL'),
            buttons: ['OK'],
          });

          await alert.present();
        }

      }, (error) => {
        console.error('error: ', error);
        loading.dismiss();
        // this.loadingModal(error.message);
      });
    } else {
      loading.dismiss();
      //this.displayError = true;
      //this.displayMessage = this.EscribeMail;
    }
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login');
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }
    
    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  gotoOldApp(view?) {
    console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }
  gotoTerms() {
    // window.open('https://blog.louderband.com/landing-page-suscripciones-cuenta-pro/');
    this.navCtrl.navigateForward('landing/terminos-y-condiciones');
  }

  gotoPolicyPrivacy() {
    // window.open('https://blog.louderband.com/landing-page-suscripciones-cuenta-pro/');
    this.navCtrl.navigateForward('landing/politicas-de-privacidad');
  }

  async loginGoogle() {
    const result = await GoogleAuth.signIn();
    console.log('loginGoogle', result);

    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('google/login', result).subscribe(async (response) => {
      const user: any = response.body;
      this.rest.storageSet('user', user);
      this.util.setUser(user);
      this.util.setToken(user.token);

      loading.dismiss();

      let picture = null;

      // if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: user.name,
          profile_image: picture,
        });*/
      // } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('home');
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      // }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });

  }

  loginApple() {
    if (Capacitor.getPlatform() === 'web') {
      this.appleWeb();
    } else {
      this.appleApp();
    }
  }

  async appleWeb() {

    const provider = new OAuthProvider('apple.com');

    signInWithPopup(this.auth, provider).then((result: UserCredential) => {
      console.log(result);
      if (result) {
        this.helpApple(result.user);
      }
    });
  }

  async appleApp() {

    let options: SignInWithAppleOptions = {
      clientId: 'com.louderband.ios',
      redirectURI: 'https://louderband-app.firebaseapp.com/__/auth/handler',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };
    SignInWithApple.authorize(options)
      .then((result: SignInWithAppleResponse) => {
        // Handle user information
        // Validate token with server and create new session
        this.helpApple(result);
      })
      .catch(error => {
        // Handle error
      });
  }

  async helpApple(response) {

    let params = {
      username: response.email,
      name: response.displayName,
      red_social: 'APPLE',
      id_usuario_red_social: response.uid,
      tokenApple: response.accessToken,
      email: response.email,
      respuesta: JSON.stringify(response),
      notification_id: '' //this.oneSignal.getPlayerId()
    };
    // alert(JSON.stringify(params));
    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('apple/login', params).subscribe(async (response) => {
      const user: any = response.body;
      this.util.setToken(user.token);
      this.rest.storageSet('user', user);
      loading.dismiss();
      let picture = null;

      if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: response.fullName.givenName + response.fullName.familyName,
          profile_image: picture,
        });*/
      } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('home');
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });
  }

}
